import { render, staticRenderFns } from "./EditAccountMailComplete.vue?vue&type=template&id=2e61bbd4&scoped=true&"
import script from "./EditAccountMailComplete.vue?vue&type=script&lang=ts&"
export * from "./EditAccountMailComplete.vue?vue&type=script&lang=ts&"
import style0 from "../Complete.scss?vue&type=style&index=0&id=2e61bbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61bbd4",
  null
  
)

export default component.exports